const { AgentPageHandler } = require('../handlers/Guest/AgentPageHandler'),
    { DistributorPageHandler } = require('../handlers/Guest/DistributorPageHandler'),
    { SupplierPageHandler } = require('../handlers/Guest/SupplierPageHandler'),
    { APIPageHandler } = require('../handlers/Guest/APIPageHandler'),
    { ContactPageHandler } = require('../handlers/Guest/ContactPageHandler');

const guestMapping = {
    Agent: AgentPageHandler,
    Distributor: DistributorPageHandler,
    Supplier: SupplierPageHandler,
    API: APIPageHandler,
    Contact: ContactPageHandler
}

module.exports = { guestMapping }